<template>
  <v-chart v-if="render" v-bind:option="option" autoresize />
</template>

<script>
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { LineChart } from 'echarts/charts';
import {
  TooltipComponent,
  LegendComponent,
  GridComponent,
} from 'echarts/components';
import VChart from 'vue-echarts';

use([
  CanvasRenderer,
  LineChart,
  TooltipComponent,
  LegendComponent,
  GridComponent,
]);

export default {
  name: "line-chart",
  components: {
    VChart,
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    multipleYAxes: {
      type: Boolean,
      default: false
    },
    axisLine: {
      type: Boolean,
      default: false
    },
    colors: {
      type: Array
    }
  },
  computed: {
    tooltip: function () {
      return {
        trigger: "axis",
      };
    },
    legend: function () {
      var legend = {};
      var data = [];
      var descriptions = {};
      if (this.value && this.value.lines) {
        for (var i = 0; i < this.value.lines.length; i++) {
          var line = this.value.lines[i];
          data.push(line.name);
          if (line.description) {
            descriptions[line.name] = line.description;
          }
        }
      }
      legend.data = data;
      if (Object.keys(descriptions).length > 0) {
        legend.tooltip = {
          trigger: "item",
          formatter: (params) => {
            if (Object.prototype.hasOwnProperty.call(descriptions, params.name)) {
              return "<div style='word-break: break-word; white-space: pre-wrap; max-width: 300px;'>"
                  + descriptions[params.name]
                  + "</div>";
            }
            return null;
          },
          show: true
        };
      }
      return legend;
    },
    grid: function () {
      return {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      };
    },
    toolbox: function () {
      return {
        feature: {
          saveAsImage: {},
        },
      };
    },
    xAxis: function () {
      return {
        type: "category",
        boundaryGap: false,
        data: this.value && this.value.keys ? this.value.keys : [],
      }
    },
    yAxis: function () {
      if (this.multipleYAxes) {
        var yAxis = [];
        for (var i = 0; i < this.legend.data.length; i++) {
          var legend = this.legend.data[i];
          var value = {
            type: "value",
            name: legend,
            position: i == 0 ? "left" : "right", // TODO: position if there are more than 2 or just don't do that
            alignTicks: true
          };
          if (this.axisLine) {
            var line = {
              show: true
            };
            if (this.colors && this.colors.length > i) {
              line.lineStyle = {
                color: this.colors[i]
              }
            }
            value.axisLine = line;
          }
          yAxis.push(value);
        }
        return yAxis;
      }
      return {
        type: "value",
      };
    },
    series: function () {
      var series = [];
      if (this.value && this.value.lines) {
        for (var i = 0; i < this.value.lines.length; i++) {
          var line = this.value.lines[i];
          var value = {
            data: line.values,
            name: line.name,
            type: "line"
          }
          if (this.multipleYAxes) {
            value.yAxisIndex = i;
          }
          series.push(value);
        }
      }
      return series;
    },
    option: function () {
      var option = {
        tooltip: this.tooltip,
        legend: this.legend,
        grid: this.grid,
        toolbox: this.toolbox,
        xAxis: this.xAxis,
        yAxis: this.yAxis,
        series: this.series,
      };
      if (this.colors) {
        option.color = this.colors;
      }
      return option;
    },
    render: function () {
      return this.option.legend.data.length > 0 && this.option.xAxis.data.length > 0 && this.option.series.length > 0;
    }
  }
};
</script>
